import { render, staticRenderFns } from "./Private.vue?vue&type=template&id=a34a1110&"
import script from "./Private.js?vue&type=script&lang=js&"
export * from "./Private.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports